import { Box, Drawer, IconButton, Typography, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'

import PracticeModeViewRenderer from './practice-mode/PracticeModeViewRenderer'
import LearnModeViewRenderer from './learn-mode/LearnModeViewRenderer'
import TryAgainMessageBlock from '../common/TryAgainMessageBlock'
import CustomTwoValueSwitch from '../common/CustomTwoValueSwitch'
import { useSimbaAIStore } from '../../store/simbaai.store'
import { debounce, Icons } from '../../utils/utilities'
import simbaLogo from '../../assets/Habba-Logo.png'
import { useSearchParams } from 'react-router-dom'
import api from '../../service/api'
import SamplePracticeModeRendererForFaculty from './practice-mode/SamplePracticeModeRendererForFaculty'
import SampleLearnModeViewRendererForFaculty from './learn-mode/SampleLearnModeRendererForFaculty'

const SimbaAIForFaculty = observer( () => {

    // const [showScrollToBottomButton, setShowScrollToBottomButton] = useState( false )
    const [loading, setLoading] = useState( true )


    const { palette } = useTheme()

    const [searchParams, setSearchParams] = useSearchParams( { simbaAIOpen: 'false', practiceQuiz: "", simbaAIMode: "learn" } )
    const simbaAIOpen = searchParams.get( 'simbaAIOpen' ) === 'true'
    const simbaAIMode = searchParams.get( 'simbaAIMode' ) || "learn"

    const SimbaAIStore = useSimbaAIStore()

    const AiMentorArea = useRef( null )


    const setSearchParamsValues = ( values ) => {
        setSearchParams( prev => {
            const newParams = new URLSearchParams( prev )
            for ( const key in values ) {
                if ( !Object.hasOwn( values, key ) ) continue
                if ( values[key] )
                    newParams.set( key, values[key] )
                else
                    newParams.delete( key )
            }
            return newParams
        }, { replace: true } )
    }

    const closeAiMentorDialog = () => {
        if ( ['simba-ai-response', 'completed-typing-simba-ai-response'].includes( SimbaAIStore.getView.current ) ) {
            if ( SimbaAIStore.getAiResponsesQueue.request ) {
                SimbaAIStore.addResponse( { topic: SimbaAIStore.getAiResponsesQueue.request, response: SimbaAIStore.getAiResponsesQueue.response } )
                SimbaAIStore.setAiResponsesQueue( { request: "", response: "" } )
            }
        }
        SimbaAIStore.cancelQuestionStream()
        SimbaAIStore.setView( 'home' )
        setSearchParamsValues( { simbaAIOpen: "", practiceQuiz: "", simbaAIMode: "", selectedSubject: "" } )
    }

    const getPracticeSessions = useCallback( async () => {
        setLoading( true )
        await SimbaAIStore.fetchPracticeSessions()
        const uniqueSubCodes = {}
        const uniqueSubjects = []
        for ( const ps of SimbaAIStore.getPracticeSessions ) {
            if ( !uniqueSubCodes[ps.subject.subject_code] ) {
                uniqueSubjects.push( ps.subject )
                uniqueSubCodes[ps.subject.subject_code] = true
            }
        }
        SimbaAIStore.setTopicsAvailableSubjects( uniqueSubjects )
        setLoading( false )
    }, [SimbaAIStore] )

    useEffect( () => {
        getPracticeSessions()
    }, [getPracticeSessions] )

    // Stop any in-flight question stream if the drawer unmounts
    useEffect( () => () => SimbaAIStore.cancelQuestionStream(), [SimbaAIStore] )


    return (
        <Box>
            <Drawer
                anchor='right'
                disablePortal
                sx={{ zIndex: 2000, }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backdropFilter: "blur(5px)"
                        }
                    },
                    paper: {
                        className: "slim-custom-scrollbar",
                        ref: AiMentorArea,
                        sx: {
                            width: { sm: "95vw", xs: "100vw" },
                            height: "100dvh",
                            maxWidth: "1200px",
                            display: "flex",
                            flexDirection: "column",
                            borderRadius: { md: "20px 0 0 20px", xs: "0" },
                            overflow: "clip"
                        }
                    }
                }}
                onClose={closeAiMentorDialog}
                open={simbaAIOpen}
            >


                <Box sx={{ zIndex: 10, backdropFilter: "blur(3px)" }} position="sticky" top="0" bgcolor={palette.primary.main + "cc"} padding='10px' display="flex" justifyContent="space-between" gap="20px" alignItems="center">
                    <Box display="flex" gap="10px" alignItems="center">
                        <Box borderRadius="10px" border={`2px solid ${palette.common.white}`} width="30px" sx={{ aspectRatio: "1 / 1", width: "30px", height: "30px" }} >
                            <Box component="img" height="100%" width="100%" sx={{ objectFit: "cover" }} src={simbaLogo} />
                        </Box>
                        <Box >
                            <Typography color={palette.common.white} fontWeight="700" fontSize="16px" component="p" > Simba AI</Typography>
                            <Typography color={palette.common.white} display={{ sm: "block", xs: "none" }} fontSize="12px" marginTop="-5px" component="p" > Practice your topics with the help of Simba AI </Typography>
                        </Box>
                    </Box>
                    <IconButton sx={{ color: palette.common.white }} onClick={closeAiMentorDialog}>
                        {Icons.default.CloseIcon}
                    </IconButton>
                </Box>

                {!loading && simbaAIMode === 'learn' && <SampleLearnModeViewRendererForFaculty closeAiMentorDialog={closeAiMentorDialog} />}

                {!loading && simbaAIMode === 'practice' && <SamplePracticeModeRendererForFaculty />}

            </Drawer>
        </Box>
    )
} )

export default SimbaAIForFaculty